export const useVideoStore = defineStore('video', {
  state: () => {
    return {
      isActive: false,
      isOpen: false,
      isPublisherConnected: false,
      isSubscriberConnected: false,
      isPublisherMuted: false,
      isSubscriberMuted: false,
      isFullscreen: false,
      tokboxTokens: null,
    };
  },

  actions: {
    resetState() {
      this.isActive = false;
      this.isOpen = false;
      this.isPublisherConnected = false;
      this.isSubscriberConnected = false;
      this.isPublisherMuted = false;
      this.isSubscriberMuted = false;
      this.isFullscreen = false;
      this.tokboxTokens = null;
    },
  },

  getters: {
  },
});
